import { format as fnsFormatDate, formatDistanceToNow, formatRelative } from 'date-fns'
import { useEffect, useState } from 'react'

export function Datetime({ date }: { date: Date }) {
	return (
		<span className="inline-flex items-center tabular-nums tracking-[-0.04em]">
			{fnsFormatDate(date, 'HH')}
			&#65109;
			{fnsFormatDate(date, 'mm')}
			<div className="w-4" />
			{fnsFormatDate(date, 'dd')}
			<div className="px-[1px]">.</div>
			{fnsFormatDate(date, 'MM')}
			<div className="px-[1px]">.</div>

			{fnsFormatDate(date, 'yyyy')}
		</span>
	)
}

function formatShortRelative(date: Date, now: Date = new Date(), ago = false): string {
	const diffMs = Math.abs(now.getTime() - date.getTime())
	const diffSec = Math.floor(diffMs / 1000)
	if (diffSec < 60) { return `${ago ? 'just now' : 'now'}` }

	const diffMin = Math.floor(diffSec / 60)
	if (diffMin < 60) { return `${diffMin}${ago ? ' minutes ago' : ' min'}` }

	const diffHr = Math.floor(diffMin / 60)
	if (diffHr < 24) { return `${diffHr}${ago ? ' hours ago' : ' hr'}` }

	const diffDay = Math.floor(diffHr / 24)
	if (diffDay < 7) { return `${diffDay}${ago ? ' days ago' : ' d'}` }

	const diffWk = Math.floor(diffDay / 7)
	if (diffWk < 4) { return `${diffWk}${ago ? ' weeks ago' : ' wk'}` }

	const diffMo = Math.floor(diffDay / 30)
	if (diffMo < 12) { return `${diffMo}${ago ? ' months ago' : ' mo'}` }

	const diffYr = Math.floor(diffDay / 365)
	return `${diffYr}${ago ? ' years ago' : ' yr'}`
}

export function TimeSince({ date, short = false, ago = false }: { date: Date; short?: boolean; ago?: boolean }) {
	return (
		<span className="">
			{short ? formatShortRelative(date, new Date(), ago) : formatRelative(date, new Date())}
		</span>
	)
}

export function TimeAgo({ date, short = false, ago = false }: { date: Date; short?: boolean; ago?: boolean }) {
	const [forceUpdate, setForceUpdate] = useState(0)

	useEffect(() => {
		const interval = setInterval(() => {
			setForceUpdate((prev) => prev + 1)
		}, 60000)
		return () => clearInterval(interval)
	}, [])

	return (
		<span title={fnsFormatDate(date, 'PPpp')}>
			{short ? formatShortRelative(date, new Date(), ago) : formatDistanceToNow(date, { addSuffix: true })}
		</span>
	)
}
